module.exports = __webpack_public_path__ + "img/il.c36a011d.svg";